module.exports = __webpack_public_path__ + "static/media/cover_ger_5_6.a30bd761.jpg";